
export class ViewManagerUI {
    static viewManagerHtml: string = `
    <div class="view-manager">
        <div class="view-manager__btns input-group">
            <button type="button" class="view-manager__btn-add btn btn-outline-secondary" aria-label="Add View"><span class="fa fa-plus"></span></button>
            <button type="button" class="view-manager__btn-edit btn btn-outline-secondary" aria-label="Edit View"><span class="fa fa-edit"></span></button>
            <button type="button" class="view-manager__btn-save btn btn-outline-secondary" aria-label="Save View"><span class="fa fa-floppy-disk"></span></button>
            <button type="button" class="view-manager__btn-delete btn btn-outline-secondary" aria-label="Delete View"><span class="fa fa-trash"></span></button>
            <button type="button" class="view-manager__btn-is-shared btn btn-outline-secondary" aria-label="Share View"><span class="fa fa-lock"></span></button>
            <select class="view-manager__select"></select>
        </div>
    </div>
    `;
}
